import { Skeleton } from '@/components/ui/Skeleton';

export default function TicketCardSkeleton() {
  return (
    <div className="m-3 flex justify-between rounded-lg px-3 py-2">
      <div className="flex w-full gap-2">
        <div className="flex flex-col items-center gap-1">
          <Skeleton className="h-6 w-6 rounded-full" />
          <Skeleton className="h-2 w-2 rounded-full" />
        </div>
        <div className="flex flex-1 flex-col gap-2">
          <Skeleton className="h-4 w-1/2 rounded" />
          <Skeleton className="h-3 w-3/4 rounded" />
        </div>
      </div>
      <Skeleton className="h-3 w-1/4 rounded" />
    </div>
  );
}
